import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/Layout/MainLayout';
import { ProtectedRoute } from './components/Auth';

// Public routes
import LandingPage from './features/home/LandingPage';
import GammaHomepage from './features/gamma-homepage';
import Login from './features/auth/Login';
import ResetPassword from './features/reset-password';

// Protected routes
import Dashboard from './features/dashboard';
import Map from './features/map';
import Project from './features/project';
import CareScore from './features/care-score';
import PatientCohorts from './features/patient-cohorts';
import Profile from './features/profile';
import Settings from './features/settings';
import ThreeDMap from './features/3dmap/ThreeDMap';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<GammaHomepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Protected Routes - All require authentication */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/map" element={
          <ProtectedRoute>
            <MainLayout>
              <Map />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/3dmap" element={
          <ProtectedRoute>
            <MainLayout>
              <ThreeDMap />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/project" element={
          <ProtectedRoute>
            <MainLayout>
              <Project />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/care-score" element={
          <ProtectedRoute>
            <MainLayout>
              <CareScore />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/patient-cohorts" element={
          <ProtectedRoute>
            <MainLayout>
              <PatientCohorts />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <MainLayout>
              <Profile />
            </MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <MainLayout>
              <Settings />
            </MainLayout>
          </ProtectedRoute>
        } />
        
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;